import { render, staticRenderFns } from "./worksheet-content.vue?vue&type=template&id=12cd8e56&"
import script from "./worksheet-content.vue?vue&type=script&lang=js&"
export * from "./worksheet-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports